import { useEffect } from "react";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { HOME_DESCRIPTION, HOME_TITLE, SITE_NAME } from "./config";
import { HomePage } from "./pages/HomePage";
import { LegalPage } from "./pages/LegalPage";

function PageEffects({ page }: { page: "home" | "privacy" | "terms" }) {
  useEffect(() => {
    const isPrivacy = page === "privacy";
    const isTerms = page === "terms";
    document.title = isPrivacy
      ? `Privacy — ${SITE_NAME}`
      : isTerms
        ? `Terms — ${SITE_NAME}`
        : HOME_TITLE;

    const description = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    if (description) {
      description.content =
        isPrivacy || isTerms
          ? `Preliminary ${isPrivacy ? "privacy policy" : "website terms"} for ${SITE_NAME}.`
          : HOME_DESCRIPTION;
    }

    if (window.location.hash) {
      window.requestAnimationFrame(() => {
        document.querySelector(window.location.hash)?.scrollIntoView();
      });
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [page]);

  return null;
}

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const page =
    path === "/privacy" ? "privacy" : path === "/terms" ? "terms" : "home";

  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <PageEffects page={page} />
      <Header />
      {page === "privacy" ? (
        <LegalPage type="privacy" />
      ) : page === "terms" ? (
        <LegalPage type="terms" />
      ) : (
        <HomePage />
      )}
      <Footer />
    </>
  );
}
